/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Relationship_Team_MemberInputs */



/**
* | output |
* | --- |
* | "Team member" |
*
* @param {Team_Relationship_Team_MemberInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_relationship_team_member = /** @type {((inputs?: Team_Relationship_Team_MemberInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Relationship_Team_MemberInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Teamlid")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membre de l'équipe")
	return /** @type {LocalizedString} */ ("Team member")
});